/* eslint-disable */
<template>
  <div>
    <div class="miniflags">
      <div v-for="cntry_selected in countries"  v-bind:key="cntry_selected">
        <country-flag :country='cntry_selected' size='normal'/>
      </div>
    </div>
    <v-stepper v-model="e1" >
    <v-stepper-header>

      <v-stepper-step :complete="e1 > 1" step="1"  >{{$t('form.steps.1')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">{{$t('form.steps.2')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3" :complete="e1 > 3" >{{$t('form.steps.3')}}</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="4"  >{{$t('form.steps.4')}}</v-stepper-step>
    </v-stepper-header>
      <v-stepper-items>
      <v-stepper-content step="1" class="step1">
        <v-container cols="6" align-self="center">
          <p><b>{{$t('form.label.choose_countries')}}</b></p>
        <ul id="countries">
          <li v-for="cntry in available_countries"
              v-bind:key="cntry"
              :class="{highlight:countries.includes(cntry)}"
              @click="() => selectCountry(cntry)" >
              <country-flag :country=' cntry ' size='big' class="big"/>
              <country-flag :country=' cntry ' size='medium' class="small"/>
              <span>
                {{ $t('countries.'+cntry) }}
              </span>
          </li>
        </ul>
        </v-container>
        <v-btn color="primary" :disabled='minCountries == 1' @click="e1 = 2">
          {{ $t("form.label.continue") }}
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="2" class="step2">

        <v-container v-for="cntry_selected in countries"  v-bind:key="cntry_selected">
          <h3><country-flag :country='cntry_selected' size='normal'/>
            {{$t('countries.'+cntry_selected)}}
          </h3>
          <v-text-field v-for="(val, field) in quantities[cntry_selected]"
            type="number"
             v-bind:key="field"
            :label="$t('form.weights.'+field)"
            v-model="quantities[cntry_selected][field]"
            suffix="kg"
          > </v-text-field>
        </v-container>

        <v-btn color="primary" @click="e1 = 1">{{ $t("form.label.back") }}</v-btn>
        <v-btn color="primary" @click="e1 = 3">{{ $t("form.label.continue") }}</v-btn>

      </v-stepper-content>

      <v-stepper-content step="3">
        <v-form v-model="valid">
         <v-text-field
            :label="$t('form.contact.company')"
            v-model="contact.company"
          > </v-text-field>
           <v-text-field
            :label="$t('form.contact.street')"
            v-model="contact.address"
          > </v-text-field>
          <v-text-field
            :label="$t('form.contact.zip')"
            v-model="contact.zip"
          > </v-text-field>
          <v-text-field
            :label="$t('form.contact.city')"
            v-model="contact.city"
          > </v-text-field>
        <v-text-field
          :label="$t('form.contact.contact_person')+' *'"
          :rules="[rules.required]"
          v-model="contact.contact_person"
        > </v-text-field>
        <v-text-field
          :label="$t('form.contact.telephone')+' *'"
          :rules="[rules.required]"
          v-model="contact.phone"
        > </v-text-field>
        <v-text-field
          :label="$t('form.contact.email')+' *'"
           :rules="[rules.required, rules.email]"
          v-model="contact.email"
          required
        > </v-text-field>
          <v-btn color="primary"   @click="e1 = 2"  >{{ $t("form.label.back") }}</v-btn>
          <v-btn color="primary" @click="e1 = 4"  :disabled='valid == false'>
            {{ $t("form.label.continue") }}
          </v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-content step="4" class="overview">
      <h3>{{$t('form.label.your_data')}}:</h3>
        <p><b v-if="contact.company">{{contact.company}}<br/></b>
          <span v-if="contact.contact_person">{{contact.contact_person}}<br/></span>
          <span v-if="contact.address">{{contact.address}}<br/>
        {{contact.zip}} {{contact.city}}</span></p>
        <p>{{contact.phone}}<br/>
        {{contact.email}}</p>
        <v-btn  small  @click="e1 = 3"  >{{ $t("form.label.edit") }}</v-btn>
        <h3>{{$t('form.label.your_options')}}:</h3>
        <table>
        <tr v-for="(country, name) in quantities" v-bind:key="country">
          <td><b>{{$t('countries.'+name)}}</b></td>
          <td><p v-for="(weight, name) in country" v-bind:key="name" v-if="weight !== ''">
            {{$t('form.weights.'+name)}}:<span> {{weight}} kg</span>
          </p></td>
        </tr>
        </table>
        <v-btn small  @click="e1 = 2"  >{{ $t("form.label.edit") }}</v-btn>
        <div class="consent">
          <input type="checkbox" id="checkbox" v-model="consent">
          <label for="checkbox">{{$t("form.label.consent")}}</label>
        </div>
        <v-btn color="primary" @click="dialog = true" :disabled="consent == false">
          {{ $t("form.label.send") }}
        </v-btn>
        <v-dialog
          v-model="dialog"
          hide-overlay
          persistent
          width="300"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text>
              {{$t('form.label.loading')}}
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
    <v-card v-if="endcard == true" elevation="24" success>
      <v-card-title>{{$t("form.endcard.header")}}</v-card-title>
      <v-card-text v-html="$t('form.endcard.text')">
      </v-card-text>
      <v-btn color="primary" @click="endcard = false, e1 = 1" >{{ $t("form.label.close") }}</v-btn>
    </v-card>
  </div>

</template>

<script>
export default {
  name: 'MultiStepForm',
  props: {},
  data() {
    return {
      e1: 0,
      consent: false,
      endcard: false,
      dialog: false,
      valid: false,
      countries: [],
      quantities: {},
      contact: {
        company: '',
        address: '',
        zip: '',
        city: '',
        contact_person: '',
        phone: '',
        email: '',
      },
      sendable: {
        contact: '',
        quantities: '',
        lang: '',
      },
      available_countries: ['bel', 'bgr', 'dnk', 'deu', 'est', 'fin', 'fra', 'grc', 'ita', 'irl', 'hrv', 'lva', 'ltu', 'lux', 'mlt', 'nld', 'nor', 'aut', 'pol', 'prt', 'rou', 'swe', 'che', 'svn', 'svk', 'esp', 'cze', 'tur', 'hun', 'gbr', 'cyp'],
      rules: {
        required: value => !!value || 'Field required',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid email.';
        },
      },
    };
  },
  methods: {
    sendData() {
      this.dialog = false;
      this.endcard = true;
      this.sendable.contact = this.contact;
      this.sendable.quantities = this.quantities;
      this.sendable.lang = this.$i18n.locale;
      // eslint-disable-next-line no-console
      console.log(this.sendable);

      this.$axios.post('https://cms.zmart24.de/mailer.php', this.sendable)
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    selectCountry(cntry) {
      const check = this.countries.includes(cntry);
      if (check === true) {
        this.countries.splice(this.countries.indexOf(cntry), 1);
        this.$delete(this.quantities, cntry);
      } else {
        this.countries.push(cntry);
        this.$set(this.quantities, cntry, { paper: '', plastic: '', glass: '', other_material: '', other_packaging: '', aluminum: '', iron: '', beverage_packing: '' });
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) { // eslint-disable-next-line no-console
        // console.log(val);
      } else {
        // eslint-disable-next-line no-undef
        setTimeout(() => (this.sendData()), 3000);
      }
    },
  },
  computed: {
    minCountries() {
      let step1state = 1;
      if (this.countries.length >= 1) {
        step1state = 0;
      } else {
        step1state = 1;
      }
      return step1state;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px 10px 0;
  cursor: pointer;
  background-color: rgb(244, 248, 246);
  color: rgb(72, 72, 72);
  padding: 1rem;
  border: 1px solid rgb(240, 240, 240);
  border-radius: 5px;
  min-width: 133px;
}
 li .flag{
   display: flex;
   margin: 0 auto;
 }
li .flag.small{
  display: none;
}
li span{
  font-size: 1.1rem;
  font-weight: bold;
  padding-top: 0.5rem;
  display: inline-block;
}
@media (max-width: 825px){
  .step1 .container{
    padding: 0;
  }
  li {
    padding: 0 0.5rem 0.5rem 0.5rem;
    min-width: 94px;
  }
  li .flag.big{
    display: none;
  }
  li .flag.small{
    display: block;
  }
  li span{
    padding-top: 0;
    font-size: 0.9rem;
    line-height: 0.9;
  }
}

a {
  color: #42b983;
}
ul#countries li.highlight{
  border-color: cornflowerblue;
  box-shadow: 2px 3px 12px rgb(22, 96, 69);
}

.miniflags{
  width: 100%;
  height: 3rem;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background: #fafafa;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2);
}
.miniflags div{
  display: inline-block;
  margin: 0.7rem 4px 0 4px;
}

@media (max-width: 680px){
  .v-text-field{
    padding-top: 0;
  }
}
.v-input.v-text-field{
  width: 70%;
  margin: 4px auto 0 auto;
}
.v-stepper__content{
  padding-left: 0;
  padding-right: 0;
}
.step2 .v-stepper__wrapper .container  h3{
  font-size: 2rem;
}
.step2 .v-stepper__wrapper .container + .container{
  padding-top: 2rem;
  border-top: 1px solid #efefef;
  margin-top: 1rem;
}

button + h3{
  margin-top: 3rem;
}
.overview h3{
  margin-bottom: 3rem;
}
.overview table{
  width: 80%;
  margin: 0 auto 1rem auto;
}
.overview table td{
  vertical-align: top;
}
.overview table td + td{
  text-align: left;
}
.overview table td p{
  padding: 0 1rem;
  margin-bottom: 0;
}
.overview table td p span{
  float: right;
}
.overview table td p:nth-child(even){
  background: #e4e4e4;
  margin-top: 5px;
}
.overview table tr:nth-child(odd){
  background: #fafafa;
}
.overview table + button{
  margin-bottom: 3rem;
}
.consent {
  margin-bottom: 2rem;
}
.theme--light.v-card{
  position: fixed;
  z-index: 10;
  top: 45%;
  color: #fff;
  margin: 0 auto;
  left: 50%;
  margin-left: -15rem;
  width: 400px;
  box-shadow: 0 0 40px rgba(0,0,0, 0.4);
}

.theme--light.v-card .v-card__title{
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  color: #000;
  display: block;
}
.theme--light.v-card .v-card__text{
  font-size: 1.2rem;
  color: #000;
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/MultiStepForm.vue